export default function( branding, parentEl ) {
    let css = null;
    let primary = '';
    let secondary = '';
    let logo = '';

    if ( branding.primaryColor ) {
        primary = `
            .primary-color { color: ${ branding.primaryColor } !important; }
            .primary-background { background: ${ branding.primaryColor } !important; }
            .primary-background-avatar { background-color: ${ branding.primaryColor }; }
            .primary-fill { fill: ${ branding.primaryColor } !important; }
            .primary-border { border-color: ${ branding.primaryColor }; }
            .primary-hover:hover { color: ${ branding.primaryColor } !important; }
        `;
    }

    if ( branding.secondaryColor ) {
        secondary = `
            .secondary-color { color: ${ branding.secondaryColor } !important; }
            .secondary-background { background: ${ branding.secondaryColor } !important; }
            .secondary-fill { fill: ${ branding.secondaryColor } !important; }
            .secondary-border { border-color: ${ branding.secondaryColor } !important; }
        `;
    }
    if ( branding.primaryLogo ) {
        logo = `
        .primary-logo { background-image: url("${ branding.primaryLogo }"); }
        `;
    }
    css = `${ primary }${ logo }${ secondary }`;

    injectStyle( css, parentEl );
}


const injectStyle =  ( css, el ) => {
    const parent = document[ el ];

    const style = document.createElement( 'style' );
    style.type = 'text/css';

    style.appendChild( document.createTextNode( css ) );

    parent.appendChild( style );
};

